import { AxiosResponse } from "axios";
import config from "../../../config";
import { DocumentRepo } from "../../Model/Dto/EmploymentEquity/DocumentRepo";
import { axiosInstance } from "../AxiosInterceptor";
import * as ApiUrls from "./ApiUrl.DocumentRepo";

export const DocumentRepoService  = {

    AddOrEditDocumentSection: (section: DocumentRepo.AddOrEditSectionDtoOut): Promise<AxiosResponse<number>> => axiosInstance.post(ApiUrls.AddOrEditDocumentSection, section ),
    Search: (sectionModuleType: number): Promise<AxiosResponse<DocumentRepo.SearchResponse>> => axiosInstance.post(`${ApiUrls.Search}?sectionModuleType=${sectionModuleType}`),
    DeleteDocumentSection: (id: number): Promise<AxiosResponse<void>> => axiosInstance.delete(ApiUrls.DeleteDocumentSection, {params:{id: id}}),
    InsertDocumentSectionItem: (parameters: DocumentRepo.InsertItemParameters, document: FormData,  headers: any): Promise<AxiosResponse<void>> => axiosInstance.post(ApiUrls.InsertDocumentSectionItem,document, {params: parameters, headers: headers} ),
    DeleteDocumentItem: (id: number): Promise<AxiosResponse<void>> => axiosInstance.delete(ApiUrls.DeleteDocumentItem, {params:{id: id}}),
    ViewDocumentItem: (id: number) => {
        const url = `${config.apiUrl}${ApiUrls.DocumentRepo}?id=${id}`;
        window.open(url);
    }
}